import ProductDescription from './ProductDescription'

const BSWildRiceProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '015',
  IsBroadband: true,
  GrainLength: '',
  Size: '',
}

export default BSWildRiceProduct
